module.exports = __webpack_public_path__ + "static/media/slim.3df4447c.svg";